import * as t from './actionTypes';

export function fireSegmentTrackCall(eventName /*: string */, eventProperties /*: Object */) {
  return {
    type: t.FIRE_SEGMENT_TRACK_CALL,
    eventName,
    eventProperties,
  };
}
